import {createSelector} from 'reselect';

import productHelpers from '../../services/product/productHelpers';
import {selectIotDeviceData} from './iotDevice';

const selectProductSettings = (state) => state.productSettings;

const makeSelectProductsToChangeRegistrationStatus = () =>
    createSelector(selectProductSettings, (state) => state.productsToChangeRegistrationStatus);

const makeSelectCurrentProductToChangeRegistrationStatus = (isHolder) =>
    createSelector(
        makeSelectProductsToChangeRegistrationStatus(),
        selectIotDeviceData,
        (productsToChangeRegistrationStatus, iotDevice) => {
            const {holder, device} = iotDevice;
            const {codentifyOriginal: codentify, deviceSerialNumber} = device || {};
            let result;

            if (productsToChangeRegistrationStatus?.length && (deviceSerialNumber || codentify)) {
                const getProductToChangeRegistrationStatus = (serialNumber, codentifyId) =>
                    productHelpers.forceFindProduct({
                        products: productsToChangeRegistrationStatus,
                        deviceSerialNumber: serialNumber,
                        codentify: codentifyId,
                    });

                switch (isHolder) {
                    case true:
                        if (!result && holder?.deviceSerialNumber) {
                            result = getProductToChangeRegistrationStatus(holder.deviceSerialNumber);
                        }
                        break;
                    case false:
                        result = getProductToChangeRegistrationStatus(deviceSerialNumber, codentify);
                        break;
                    default:
                        result = getProductToChangeRegistrationStatus(deviceSerialNumber, codentify);

                        if (!result && holder?.deviceSerialNumber) {
                            result = getProductToChangeRegistrationStatus(holder.deviceSerialNumber);
                        }
                }
            }

            return result;
        }
    );

const makeSelectDevicePurchaseDate = () => createSelector(selectProductSettings, (state) => state.devicePurchaseData);
const makeSelectHolderPurchaseDate = () => createSelector(selectProductSettings, (state) => state.holderPurchaseData);

export {
    makeSelectCurrentProductToChangeRegistrationStatus,
    makeSelectDevicePurchaseDate,
    makeSelectHolderPurchaseDate,
    makeSelectProductsToChangeRegistrationStatus,
};
